<template>
    <div>
        <CopyToClipboard :site="`signature-${site}`" />
        <div class="signature" :id="`signature-${site}`">
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                    <td>
                        <a v-if="siteData.url" style="text-decoration: none;" :href="siteData.url">
                            <span v-html="siteData.heading"></span>
                        </a>
                        <p v-if="siteData.sitesList" v-html="siteData.sitesList"
                           style="font-family: sans-serif, verdana; font-size: 14px; line-height: 1.2; color: #63666a; margin: 2px 0px"/>
                    </td>
                    </tr>
                </tbody>
            </table>
            <table v-if="!formFields.macClient" style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                        <td v-if="siteData.facebook" width="20px">
                            <a
                            style="text-decoration: none;"
                            :href="siteData.facebook"
                            >
                            <img
                                alt="Facebook"
                                :src="socialIcons.facebook_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.twitter" width="20px">
                            <a style="text-decoration: none;" :href="siteData.twitter">
                            <img
                                alt="Twitter"
                                :src="socialIcons.twitter_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.linkedin" width="20px">
                            <a style="text-decoration: none;" :href="siteData.linkedin">
                                <img 
                                    alt="LinkedIn" :src="socialIcons.linkedin_continued"
                                    style="border: 0px solid #FFFFFF"
                                >
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style="height: 1px; background: #FFFFFF; width: 600px; padding: 0px; margin: 0px"><hr></div>
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF; margin-top: 5px;">
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div style="font-family: sans-serif, verdana; font-size: 14px; line-height: 1.0; color: #63666a;">
                                {{formFields.firstName}} {{formFields.lastName}}
                            </div>
                            <div style="font-family: sans-serif, verdana; font-size: 10px; line-height: 1.0; color: #97999b; font-weight: 300;"
                                 v-bind:style="!formFields.pronouns ? 'padding: 0px 0px 10px 0px;' : ''">
                                {{formFields.title}}
                            </div>
                            <div v-if="formFields.pronouns" style="font-family: sans-serif, verdana; font-size: 10px; line-height: 1.0; color: #97999b; padding: 0px 0px 10px 0px; font-weight: 300;">
                                ({{formFields.pronouns}})
                            </div>
                            <div v-if="formFields.emailUser.trim().length" style="font-family: sans-serif, verdana; font-size: 10px; line-height: 1.2;">
                                <a style="color: #63666a; font-weight: normal;" :href="`mailto:${formFields.emailUser}${siteData.email}`">
                                    {{formFields.emailUser}}{{siteData.email}}
                                </a>
                            </div>
                            <div v-if="formFields.extension.trim().length" style="font-family: sans-serif, verdana, sans-serif; font-size: 10px; line-height: 1.4; color: #63666a;">
                                <span style="color: #63666a;">T:</span>
                                {{siteData.phone}}, ext. {{formFields.extension}}
                            </div>
                            <div v-else-if="formFields.directLine.trim().length" style="font-family: sans-serif, verdana, sans-serif; font-size: 10px; line-height: 1.2; color: #63666a;">
                                <span style="color: #63666a;">T:</span>
                                {{formFields.directLine}}
                            </div>


                            <div  v-if="formFields.fax.trim().length" style="font-family: sans-serif, verdana, sans-serif; font-size: 10px; line-height: 1.2; color: #63666a;">
                                <span style="color: #63666a;">F:</span>
                                {{formFields.fax}}
                            </div>
                            <div v-if="formFields.mobile.trim().length" style="font-family: sans-serif, verdana, sans-serif; font-size: 10px; line-height: 1.2; color: #63666a;">
                                <span style="color: #63666a;">M:</span>
                                {{formFields.mobile}}
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SiteData from "../../SiteData.js";
import CopyToClipboard from '../CopyToClipboard';

export default {
  name: "Sales",
  data: function() {
    return {
      siteData: "",
      socialIcons: SiteData.socialIcons
    };
  },
  components: {
      CopyToClipboard
  },
  props: {
    formFields: Object,
    site: String
  },
  created: function() {
    this.siteData = SiteData[this.$props.site];
  }
};
</script>

